import { LinkButton } from '@/atoms/Button/LinkButton'
import { FlexColumn } from '@/atoms/FlexContainers'
import { VideoCheckOutlineIcon } from '@/atoms/Icons/VideoCheckOutlineIcon'
import { HeadingLG, HeadingSM, ParagraphSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useSafeTrack } from '@/utils/analytics/safe-analytics'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { Label } from '@/views/GuildCreateView/components/Inputs'

export const SubmitSection = () => {
  const { t } = useTranslate('about')
  const track = useSafeTrack()

  const handleClick = () => {
    track('About Page Submit Project Button Clicked')
  }

  return (
    <section className="py-[72px]" id="submit">
      <FlexColumn className="mx-auto gap-8 px-8 md:w-[693px] md:px-0 xl:w-fit xl:max-w-[1242px]">
        <FlexColumn className="gap-6">
          <VideoCheckOutlineIcon size={48} />
          <HeadingLG weight="bold">{t('submittingProjectToAngel', 'Submitting a Project to Angel')}</HeadingLG>
          <Translate t={t} i18nKey="submittingProjectBlurbv2">
            <ParagraphSM>
              Are you a filmmaker with a project that amplifies light? We’re seeking concept videos (Torches) and
              completed films or series that are true, honest, noble, just, authentic, lovely, admirable, and excellent.
              Whether your project is newly created or already licensed, if it aligns with our mission, follow these
              steps to submit.
            </ParagraphSM>
          </Translate>
        </FlexColumn>
        <div className="grid grid-cols-1 gap-x-16 gap-y-8">
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('submitProjectStep', '1. Submit Your Project')}</HeadingSM>
            <Translate t={t} i18nKey="submitProjectBlurb">
              <ParagraphSM>
                You’ll submit details about your project, its current stage of production, a video file, and the
                application fee.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('guildVotingStep', '2. Guild Voting')}</HeadingSM>
            <Translate t={t} i18nKey="guildVoteBlurb">
              <ParagraphSM>
                The Guild will vote on your project and decide if it meets the requirements for Angel partnership.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('angelReviewStep', '3. Angel Review')}</HeadingSM>
            <Translate t={t} i18nKey="angelReviewBlurb">
              <ParagraphSM>
                Once you pass the Guild, we&apos;ll consider your project for a potential partnership with Angel.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('distributionStep', '4. Distribution')}</HeadingSM>
            <Translate t={t} i18nKey="distributionStepBlurb">
              <ParagraphSM>
                We’ll work with Angel Funding to start raising the capital to fund the production.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
        </div>
        <LinkButton className="h-14 lg:w-1/3" href={paths.submit.index} onClick={handleClick} variant="white">
          <Label>{t('submitYourProject', 'Submit Your Project')}</Label>
        </LinkButton>
      </FlexColumn>
    </section>
  )
}
